module.exports = __webpack_public_path__ + "img/proposal-empty.178bfabf.svg";